(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cs-guarantee-ship-by"] && !Shopify.designMode) return;
  try {
    const CS_SHIP_BY_MAX_LOOKAHEAD = 60;
  const CS_COUNTRY_CACHE_KEY = 'cs-ship-by-country';

  /**
   * The visitor's IP country, from the same uncached endpoint Shopify's own
   * country recommendation uses. Cached per tab so one PDP visit costs one
   * request at most.
   * @returns {Promise<string|null>} ISO-3166 alpha-2, or null if unavailable.
   */
  async function csDetectCountry() {
    try {
      const cached = sessionStorage.getItem(CS_COUNTRY_CACHE_KEY);
      if (cached) return cached;
    } catch (error) {
      // Private mode or blocked storage. Fall through to the fetch.
    }

    try {
      const response = await fetch('/browsing_context_suggestions.json', {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return null;
      const data = await response.json();
      const code = data?.detected_values?.country?.handle;
      if (!code) return null;
      try {
        sessionStorage.setItem(CS_COUNTRY_CACHE_KEY, code);
      } catch (error) {
        // Storage unavailable. The value is still usable this time.
      }
      return code;
    } catch (error) {
      return null;
    }
  }

  class CsShipBy extends HTMLElement {
    connectedCallback() {
      this.#update();
      this.#updateRegion();
      this.#wireGuarantee();
    }

    /**
     * Point the guarantee half at the dialog the Trust Guarantee block owns.
     * Assigning onclick rather than adding a listener keeps this idempotent,
     * because Horizon's morph engine can re-run connectedCallback.
     */
    #wireGuarantee() {
      const trigger = this.querySelector('[data-cs-guarantee-trigger]');
      if (!trigger) return;

      const selector = this.dataset.guaranteeDialog;
      const attach = () => {
        let dialog = null;
        try {
          dialog = selector ? document.querySelector(selector) : null;
        } catch (error) {
          // A malformed selector must not take the rest of the pill down.
        }

        if (!dialog || typeof dialog.showModal !== 'function') {
          // Nothing to open, usually because the Trust Guarantee block is
          // hidden. Go inert but keep every style: removing the class here
          // exposed the browser's default grey button.
          trigger.removeAttribute('aria-haspopup');
          trigger.onclick = null;
          trigger.disabled = true;
          return;
        }

        trigger.disabled = false;
        trigger.onclick = () => dialog.showModal();
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attach, { once: true });
        return;
      }
      attach();
    }

    /**
     * Show the "from" suffix only for the listed countries. Left at whatever
     * Liquid rendered if the country cannot be determined.
     */
    async #updateRegion() {
      const primary = this.querySelector('[data-cs-region]');
      const secondary = this.querySelector('[data-cs-region-2]');
      if (!primary && !secondary) return;

      const codes = (value) =>
        (value || '')
          .split(',')
          .map((entry) => entry.trim().toUpperCase())
          .filter(Boolean);

      const allowed = codes(this.dataset.regionCountries);
      const allowedSecondary = codes(this.dataset.regionCountries2);
      if (allowed.length === 0 && allowedSecondary.length === 0) return;

      const country = await csDetectCountry();
      if (!country) return;
      const code = country.toUpperCase();

      // The first list wins, and Warehouse stock ships from Texas wherever it
      // goes, so it never claims the second origin.
      const isWarehouse = this.dataset.isWarehouse === 'true';
      const inPrimary = allowed.includes(code);
      const inSecondary = !inPrimary && !isWarehouse && allowedSecondary.includes(code);

      if (primary) primary.hidden = !inPrimary;
      if (secondary) secondary.hidden = !inSecondary;
    }

    #update() {
      const target = this.querySelector('[data-cs-ship-date]');
      if (!target) return;

      const businessDays = Number.parseInt(this.dataset.businessDays, 10);
      if (!Number.isFinite(businessDays) || businessDays < 0) return;

      const cutoffHour = Number.parseInt(this.dataset.cutoffHour, 10);
      const holidays = new Set(
        (this.dataset.holidays || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean)
      );

      const now = this.#civilNow(this.dataset.timezone);
      if (!now) return;

      const date = now.date;
      if (Number.isFinite(cutoffHour) && now.hour >= cutoffHour) {
        date.setUTCDate(date.getUTCDate() + 1);
      }

      let counted = 0;
      let steps = 0;
      while (counted < businessDays && steps < CS_SHIP_BY_MAX_LOOKAHEAD) {
        date.setUTCDate(date.getUTCDate() + 1);
        steps += 1;
        if (this.#isBusinessDay(date, holidays)) counted += 1;
      }
      if (counted < businessDays) return;

      // Zero business days, or a holiday, can leave the cursor on a day nothing
      // ships. Roll forward to the next day that does.
      let rolls = 0;
      while (!this.#isBusinessDay(date, holidays) && rolls < CS_SHIP_BY_MAX_LOOKAHEAD) {
        date.setUTCDate(date.getUTCDate() + 1);
        rolls += 1;
      }
      if (!this.#isBusinessDay(date, holidays)) return;

      target.dateTime = this.#toIso(date);
      target.textContent = this.#format(date);
    }

    /**
     * Today's calendar date and hour in the fulfilment centre's timezone.
     * The date is carried as a UTC-midnight Date so that adding whole days
     * can never be knocked sideways by a daylight-saving change.
     * @param {string} [timeZone] IANA name. Falls back to the shopper's own.
     * @returns {{date: Date, hour: number}|null}
     */
    #civilNow(timeZone) {
      try {
        const parts = Object.fromEntries(
          new Intl.DateTimeFormat('en-CA', {
            timeZone: timeZone || undefined,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            hourCycle: 'h23',
          })
            .formatToParts(new Date())
            .map((part) => [part.type, part.value])
        );
        const hour = Number(parts.hour) % 24;
        return {
          date: new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day))),
          hour,
        };
      } catch (error) {
        // An invalid timezone name would otherwise take the whole pill down.
        const fallback = new Date();
        return {
          date: new Date(Date.UTC(fallback.getFullYear(), fallback.getMonth(), fallback.getDate())),
          hour: fallback.getHours(),
        };
      }
    }

    /**
     * @param {Date} date
     * @param {Set<string>} holidays
     * @returns {boolean}
     */
    #isBusinessDay(date, holidays) {
      const weekday = date.getUTCDay();
      if (weekday === 0 || weekday === 6) return false;
      return !holidays.has(this.#toIso(date));
    }

    /**
     * @param {Date} date
     * @returns {string} YYYY-MM-DD
     */
    #toIso(date) {
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${date.getUTCFullYear()}-${month}-${day}`;
    }

    /**
     * @param {Date} date
     * @returns {string}
     */
    #format(date) {
      const locale = document.documentElement.lang || 'en';
      const format = this.dataset.dateFormat;

      if (format === 'weekday') {
        return new Intl.DateTimeFormat(locale, {
          timeZone: 'UTC',
          weekday: 'short',
          month: 'short',
          day: 'numeric',
        }).format(date);
      }

      const base = new Intl.DateTimeFormat(locale, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
      }).format(date);

      if (format !== 'ordinal' || !locale.toLowerCase().startsWith('en')) return base;
      return base + this.#ordinalSuffix(date.getUTCDate());
    }

    /**
     * @param {number} day
     * @returns {string}
     */
    #ordinalSuffix(day) {
      if (day > 10 && day < 14) return 'th';
      if (day % 10 === 1) return 'st';
      if (day % 10 === 2) return 'nd';
      if (day % 10 === 3) return 'rd';
      return 'th';
    }
  }

  if (!customElements.get('cs-ship-by')) {
    customElements.define('cs-ship-by', CsShipBy);
  }
  } catch(e) { console.error(e); }
})();

})();
